
import { Grid, Typography, InputAdornment } from '@material-ui/core';
import DatePicker from 'react-datepicker';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import locale from 'date-fns/locale/fr';
import 'react-datepicker/dist/react-datepicker.css';
import Input from '../../Input'

export const InputField = ({ description, value, onChange, field, valueSymbol, error }) => (
	<Grid container spacing={1} alignItems="center" className='px-1'>
		<Grid item xs={9}>
			<Typography variant="body2">{description}</Typography>
		</Grid>
		<Grid item xs={3}>
			<Input
				margin='dense'
				type='number'
				placeholder='20'
				value={value}
				onChange={(e) => onChange(e, field)}
				InputProps={{
					endAdornment: <InputAdornment position='end'>{valueSymbol}</InputAdornment>
				}}
				style={{ width: '50px' }}
				error={error}
			/>
		</Grid>
	</Grid>
);


export const DatePickerField = ({ label, date, time, onDateChange, onTimeChange, minDate }) => (
	<Grid container alignItems="center" spacing={2}>
		<Grid item xs={12} sm={4}>
			<Typography variant="body2">{label}</Typography>
		</Grid>
		<Grid item xs={5} sm={4}>
			<DatePicker
				selected={date}
				onChange={onDateChange}
				locale={locale}
				dateFormat="dd/MM/yyyy"
				minDate={minDate}
				customInput={<Input
					value={date}
					onClick={onDateChange}
					onChange={onDateChange}
					fullWidth
					InputProps={{ endAdornment: <ArrowDropDownIcon style={{ cursor: 'pointer' }} /> }}
					cursor='pointer'

				/>}

			/>
		</Grid>
		<Grid item xs={1} sm={1}>
			<Typography variant="body2" align="center">à</Typography>
		</Grid>
		<Grid item xs={4} sm={3} >
			<Input
				type="time"
				value={time}
				onChange={onTimeChange}
				cursor='pointer'
				fullWidth
			/>
		</Grid>
	</Grid>
);
